module.exports = __webpack_public_path__ + "img/pro-community-background.8fef76fb.svg";